module.exports = __webpack_public_path__ + "img/brush_hippo_teeth_splash.a23433bd.png";